module.exports = __webpack_public_path__ + "img/source03_m4.b0994464.png";